const types = {
    RESULT_SET_STATE: 'RESULT_SET_STATE',
};

const resultActions = {
    types,

    setResultState(newState) {
        newState.metaData.isLoaded = Object.keys(newState.questions).length > 0;
        return { type: types.RESULT_SET_STATE, newState };
    },
};

export default resultActions;
